import https from './https'
import { javaEndPoint } from './config'

// 获取云服务文件接口
export function getPicPrefix () {
  return 'https://release-1.oss-cn-hangzhou.aliyuncs.com/uploadFile'
}

// 扫一扫单位信息
export function unitDetails (obj, success) {
  https.fetchGet(javaEndPoint + '/api/v1/unitQrCodeScan/unitDetails', obj, false, true).then(success)
}
// 接受分享
export function acceptShareInvite (obj, success) {
  https.fetchPost(javaEndPoint + '/api/v1/im/acceptShareInvite', obj, true, true).then(success)
}
// 扫码获取用户信息
export function getUserCodeDetails (obj, success) {
  https.fetchGet(javaEndPoint + '/api/v1/user/getUserCodeDetails', obj, true, true).then(success)
}
// 绑定
export function getWetchat (obj, success) {
  https.fetchPost(javaEndPoint + '/api/v1/user/getWetchat', obj, true, true).then(success)
}
// 校验是否绑定过
export function getCode (obj, success) {
  https.fetchPost(javaEndPoint + '/api/v1/user/getCode', obj, true, true).then(success)
}
// 获取验证码
export function getWxCode (obj, success) {
  https.fetchGet(javaEndPoint + '/api/v1/user/getWxCode', obj, true, true).then(success)
}
// 解绑用户
export function wxUnbind (obj, success) {
  https.fetchPost(javaEndPoint + '/api/v1/user/wxUnbind', obj, true, true).then(success)
}
// 专题宣传内容
export function trainingSpecialContentPage (obj, success) {
  https.fetchPost(javaEndPoint + '/api/v1/trainingPlan/trainingSpecialContentPage', obj, true, true).then(success)
}
export function problemReportList (obj, success) {
  https.fetchPost(javaEndPoint + '/mobile/h5/problemReport/list', obj, true, true).then(success)
}
export function problemReportDetails (obj, success) {
  https.fetchGet(javaEndPoint + '/mobile/h5/problemReport/details', obj, true, true).then(success)
}

// 专题宣传内容详情
export function trainingPlanDetails (obj, success) {
  https.fetchPost(javaEndPoint + '/api/v1/trainingPlan/h5TrainingPlanDetails', obj, true, true).then(success)
}

// 责任清单-H5详情根据unitId获取
export function getInventoryByUnitId (obj, success) {
  https.fetchPost(javaEndPoint + '/api/v1/responsibilityInventory/detailsByUnitId', obj, true, true).then(success)
}
// 小程序培训列表
export function trainingUserPlan (obj, success) {
  https.fetchPost(javaEndPoint + '/mobile/v1/training/trainingUserPlan', obj, true, true).then(success)
}
// 小程序培训详情
export function minAppTrainingPlanDetails (obj, success) {
  https.fetchPost(javaEndPoint + '/mobile/v1/trainingPlan/trainingPlanDetails', obj, true, true).then(success)
}
// 小程序培训详情 已读未读列表
export function listTrainingPlanRead (obj, success) {
  https.fetchPost(javaEndPoint + '/mobile/v1/trainingPlan/listTrainingPlanRead', obj, true, true).then(success)
}
export function problemReportNodeList (obj, success) {
  https.fetchPost(javaEndPoint + '/mobile/h5/problemReportNode/list', obj, true, true).then(success)
}
export function queryByPage (obj, success) {
  https.fetchPost(javaEndPoint + '/mobile/h5/buildUnitImport/queryByPage', obj, true, true).then(success)
}
export function getDetailsById (obj, success) {
  https.fetchGet(javaEndPoint + '/mobile/h5/buildUnitImport/getDetailsById', obj, true, true).then(success)
}
export function randomReportQueryByPage (obj, success) {
  https.fetchPost(javaEndPoint + '/mobile/h5/randomReport/queryByPage', obj, true, true).then(success)
}
export function randomReportGetDetailsById (obj, success) {
  https.fetchGet(javaEndPoint + '/mobile/h5/randomReport/getDetailsById', obj, true, true).then(success)
}
export function listEnum (obj, success) {
  https.fetchPost(javaEndPoint + '/mobile/h5/sysEnum/listEnum', obj, true, true).then(success)
}
export function uploadFileOss (obj, success) {
  https.uploadFile(javaEndPoint + '/mobile/sysFile/uploadFileOss', obj).then(success)
}
export function getUnitDetails (obj, success) {
  https.fetchGet(javaEndPoint + '/mobile/h5/unit/getUnitDetails', obj, true, true).then(success)
}
export function randomReportAdd (obj, success) {
  https.fetchPost(javaEndPoint + '/mobile/h5/randomReport/add', obj, true, true).then(success)
}
export function faultReportAdd (obj, success) {
  https.fetchPost(javaEndPoint + '/mobile/h5/faultReport/add', obj, true, true).then(success)
}
export function faultReportDetails (obj, success) {
  https.fetchPost(javaEndPoint + '/mobile/h5/faultReport/details', obj, true, true).then(success)
}
export function frequentlyAskedQuestions (obj, success) {
  https.fetchPost(javaEndPoint + '/mobile/h5/faultReport/frequentlyAskedQuestions', obj, true, true).then(success)
}
export function listDeviceByImei (obj, success) {
  https.fetchPost(javaEndPoint + '/mobile/h5/faultReport/listDeviceByImei', obj, true, true).then(success)
}
export function faultReportPageList (obj, success) {
  https.fetchPost(javaEndPoint + '/mobile/h5/faultReport/pageList', obj, true, true).then(success)
}
export function getDeviceInfoByCodeId (obj, success) {
  https.fetchGet(javaEndPoint + '/mobile/h5/faultReport/getDeviceInfoByCodeId', obj, true, true).then(success)
}
export function gatewayMuteOrResetOrFiring (obj, success) {
  https.fetchPost(javaEndPoint + '/mobile/v1/gatewayLinkage/gatewayMuteOrResetOrFiring', obj, true, true).then(success)
}

export default {
  gatewayMuteOrResetOrFiring,
  getDeviceInfoByCodeId,
  faultReportAdd,
  faultReportDetails,
  frequentlyAskedQuestions,
  listDeviceByImei,
  faultReportPageList,
  randomReportAdd,
  getUnitDetails,
  uploadFileOss,
  listEnum,
  randomReportGetDetailsById,
  randomReportQueryByPage,
  getDetailsById,
  queryByPage,
  problemReportNodeList,
  problemReportDetails,
  problemReportList,
  listTrainingPlanRead,
  minAppTrainingPlanDetails,
  getPicPrefix,
  trainingUserPlan,
  wxUnbind,
  getWxCode,
  getWetchat,
  getCode,
  unitDetails,
  acceptShareInvite,
  getUserCodeDetails,
  trainingSpecialContentPage,
  trainingPlanDetails,
  getInventoryByUnitId
}



// WEBPACK FOOTER //
// ./src/common/api.js